import * as React from "react";
const IconCheckBox = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M61.6 8.8c-.9-.9-2.3-.9-3.2 0l-3.6 3.6v-.7c0-3.4-2.8-6.3-6.3-6.3H8c-3.4 0-6.3 2.8-6.3 6.3v40.6c0 3.4 2.8 6.3 6.3 6.3h40.6c3.4 0 6.3-2.8 6.3-6.3V18.8l6.8-6.8c.8-.9.8-2.3-.1-3.2M50.3 52.3c0 1-.8 1.8-1.8 1.8H8c-1 0-1.8-.8-1.8-1.8V11.7C6.3 10.8 7 10 8 10h40.6c1 0 1.8.8 1.8 1.8V17L40.1 27.2 33.9 21c-.9-.9-2.3-.9-3.2 0s-.9 2.3 0 3.2l7.8 7.8s.1.1.2.1l.2.2c.1 0 .1.1.2.1s.1.1.2.1.2.1.3.1h1c.1 0 .2-.1.4-.1h.1c.1 0 .2-.1.3-.2 0 0 .1 0 .1-.1.1-.1.2-.1.3-.2l8.6-8.6v28.9z" />
  </svg>
);
export default IconCheckBox;
